import React from "react";
import { Form } from "react-bootstrap";
import { FaCalendarAlt, FaUmbrellaBeach, FaBookOpen } from "react-icons/fa";
import Loader from "../../../components/Loader/Loader";
import Button from "../../../components/Button/Button";
import AssignmentGrid from "../../../components/AssignmentGrid/AssignmentGrid";

const AttendanceTeacherMapForm = ({
  closeModal,
  submitHandler,
  programData,
  program_ids,
  leave_approval_program_ids,
  onSelectAllApproverProgramHandler,
  onApproverProgramHandler,
  onSwitchChange,
  onInputChange,
  homework_program_ids,
  onHomeworkSwitchChange,
  onHomeworkInputChange,
  loader,
}) => {
  return (
    <React.Fragment>
      {loader && <Loader />}
      <Form onSubmit={submitHandler}>
        <div className="row">
          <AssignmentGrid
            label="Attendance Class"
            icon={<FaCalendarAlt />}
            items={programData}
            selectedIds={program_ids}
            onToggle={onInputChange}
            onSelectAll={onSwitchChange}
            switchName="program_ids"
          />

          <div className="col-md-12 mt-3">
            <AssignmentGrid
              label="Leave Approver Class"
              icon={<FaUmbrellaBeach />}
              items={programData}
              selectedIds={leave_approval_program_ids}
              onToggle={onApproverProgramHandler}
              onSelectAll={onSelectAllApproverProgramHandler}
              switchName="leave_approval_program_ids"
            />
          </div>

          <div className="col-md-12 mt-3">
            <AssignmentGrid
              label="Homework View Classes"
              icon={<FaBookOpen />}
              items={programData}
              selectedIds={homework_program_ids}
              onToggle={onHomeworkInputChange}
              onSelectAll={onHomeworkSwitchChange}
              switchName="homework_program_ids"
            />
          </div>
        </div>
        <div className="d-flex justify-content-end mt-3">
          <div>
            <Button variant="danger" type="button" onClick={closeModal}>
              Close
            </Button>
            <Button variant="primary" type="submit" className="mx-1">
              Submit
            </Button>
          </div>
        </div>
      </Form>
    </React.Fragment>
  );
};

export default AttendanceTeacherMapForm;
